import { __extends } from "tslib";
import { CreateDeliveryStreamInput, CreateDeliveryStreamOutput } from "../models/index";
import { deserializeAws_json1_1CreateDeliveryStreamCommand, serializeAws_json1_1CreateDeliveryStreamCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var CreateDeliveryStreamCommand = /** @class */ (function (_super) {
    __extends(CreateDeliveryStreamCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CreateDeliveryStreamCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    CreateDeliveryStreamCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: CreateDeliveryStreamInput.filterSensitiveLog,
            outputFilterSensitiveLog: CreateDeliveryStreamOutput.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateDeliveryStreamCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1CreateDeliveryStreamCommand(input, context);
    };
    CreateDeliveryStreamCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1CreateDeliveryStreamCommand(output, context);
    };
    return CreateDeliveryStreamCommand;
}($Command));
export { CreateDeliveryStreamCommand };
//# sourceMappingURL=CreateDeliveryStreamCommand.js.map